export default "__VITE_ASSET__5443ed5b__"